module.exports = __webpack_public_path__ + "img/b-pink-m@2x.7693bde5.png";